<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <div class="auth-wrapper auth-v2">

      <b-row class="auth-inner m-0">

        <!-- Brand logo-->
        <b-link class="brand-logo">
          <vuexy-logo />
          <!-- <h2 class="brand-text text-primary ml-1">
          Vuexy
        </h2> -->
        </b-link>
        <!-- /Brand logo-->

        <!-- Left Text-->
        <b-col
          lg="8"
          class="d-none d-lg-flex align-items-center p-5"
        >
          <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
            <b-img
              fluid
              :src="imgUrl"
              alt="Login V2"
            />
          </div>
        </b-col>
        <!-- /Left Text-->

        <!-- Login-->
        <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-5"
        >
          <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
          >
            <b-card-title
              class="mb-1 font-weight-bold"
              title-tag="h2"
            >
              Selamat Datang 👋
            </b-card-title>
            <b-card-text class="mb-2">
              Silakan Masuk Menggunakan Akun Anda
            </b-card-text>

            <!-- form -->
            <validation-observer
              ref="loginForm"
              #default="{ invalid }"
            >
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent="login"
              >

                <!-- email -->
                <b-form-group
                  label-for="email"
                  label="Email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    rules="required"
                  >
                    <b-form-input
                      id="email"
                      v-model="userEmail"
                      name="login-email"
                      :state="errors.length > 0 ? false : null"
                      placeholder="john@example.com"
                      autofocus
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="password">Password</label>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="password"
                        v-model="password"
                        :type="passwordFieldType"
                        class="form-control-merge"
                        :state="errors.length > 0 ? false : null"
                        name="login-password"
                        placeholder="Password"
                      />

                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- submit button -->
                <b-button
                  variant="primary"
                  type="submit"
                  block
                  :disabled="invalid"
                >
                  Masuk
                </b-button>
              </b-form>
            </validation-observer>

            <b-card-text
              class="text-center mt-2"
              style="display:none;"
            >
              <span>Belum mempunyai Akun? </span>
              <b-link :to="{ name: 'auth-register' }">
                <span>&nbsp;Klik disini</span>
              </b-link>
            </b-card-text>

          </b-col>
        </b-col>
        <!-- /Login-->
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BOverlay, BButton, BForm, BFormInput, BFormGroup, BLink, BCardTitle, BImg, BCardText, BInputGroup, BInputGroupAppend, VBTooltip,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import store from '@/store/index'
import loginV2Img from '@/assets/images/pages/login-v2.svg'
import loginV2DarkImg from '@/assets/images/pages/login-v2-dark.svg'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    // BSV
    BOverlay,
    BButton,
    BRow,
    BCol,
    BImg,
    BForm,
    BFormInput,
    BFormGroup,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      sideImg: loginV2Img,
      userEmail: '',
      password: '',
      status: '',
      role: '',
      show: false,
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        return loginV2DarkImg
      }
      return this.sideImg
    },
  },
  created() {
    const sso = process.env.VUE_APP_USING_SSO === 'true'
    if (!sso) {
      if (localStorage.getItem('sesnotify') === 'on') {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Session',
            icon: 'CoffeeIcon',
            variant: 'warning',
            text: 'Sesi login anda telah berakhir, Silakan login kembali.',
          },
        })
        localStorage.removeItem('sesnotify')
      }
    }

    if (sso && useJwt.getToken()) {
      this.$router.push({ name: 'dashboard-sparing' })
    }
  },
  methods: {
    login() {
      this.show = true
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt.login({
            email: this.userEmail,
            password: this.password,
            platform_id: process.env.VUE_APP_PLATFORM_ID,
          })
            .then(response => {
              localStorage.getItem('acessToken', localStorage.accessToken)
              useJwt.setToken(response.data.data.token)
              useJwt.getProfile().then(resProfile => {
                const userData = {
                  id: resProfile.data.data.id,
                  fullName: resProfile.data.data.name,
                  username: resProfile.data.data.name,
                  password: '',
                  avatar: resProfile.data.data.photo,
                  email: resProfile.data.data.email,
                  data: resProfile.data.data,
                  role: this.role,
                  ability: [
                    {
                      action: 'manage',
                      subject: 'all',
                    },
                  ],
                }
                localStorage.setItem('sesnotify', 'on')
                localStorage.setItem('userData', JSON.stringify(userData))
                this.$ability.update(userData.ability)
                let nameUrl
                // useJwt.getPrivilege().then(resPrivilege => {
                useJwt.getPrivilegeUserPlatform().then(resPrivilege => {
                  nameUrl = resPrivilege.data.data.privilege_category[0].privilege_category[0].url

                  this.$router.replace({ name: nameUrl })
                    .then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Welcome ${userData.fullName || userData.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                        },
                      })
                    })
                    .catch(error => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Welcome ${userData.fullName || userData.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                        },
                      })
                      console.log(error)
                      this.$refs.loginForm.setErrors(error)
                    })
                })
              })
              this.show = false
            })
            .catch(({ response: { data } }) => {
              const errMessage = data?.error?.message
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Failed',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: errMessage || 'Incorrect Email or Password',
                },
              })
              this.show = false
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
